/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dropdownItemOfintSchema } from './dropdownItemOfintSchema.ts';
import { z } from 'zod';

export const createCostCenterSchema = z.object({
  name: z.coerce.string().min(1).max(500),
  client: z.lazy(() => dropdownItemOfintSchema),
  isVisible: z.boolean(),
});
